import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
import { triggerWindowResizeEvent } from '@/utils/util';
export default {
  name: 'Bar',
  props: {
    dataSource: {
      type: Array,
      required: true
    },
    yaxisText: {
      type: String,
      default: 'y'
    },
    title: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 254
    }
  },
  data: function data() {
    return {
      padding: ['auto', 'auto', '40', '50']
    };
  },
  computed: {
    scale: function scale() {
      return [{
        dataKey: 'y',
        alias: this.yaxisText
      }];
    }
  },
  mounted: function mounted() {
    triggerWindowResizeEvent();
  }
};